<template>
  <div class="app-components">
    <ul>
      <li :class="{ active: item.name === active.name }" v-for="(item, key) in components" :key="key">
        <span>{{ item.label }}</span>
        <a href="javascript:;" @click="handleBtnSettingClick(item)">
          <i class="el-icon-setting"></i>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'app-components',
  props: {
    active: {
      type: Object,
      default: () => ({})
    },
    components: {
      type: [ Object, Array ],
      default: () => []
    }
  },

  methods: {
    handleBtnSettingClick (item) {
      this.$emit('select', item)
    },

    handleReset () {
      this.$emit('reset')
    },

    handleSave () {
      this.$emit('save')
    }
  }
}
</script>

<style lang="scss">
.app-components {
  position: relative;
  height: 100%;

  > ul {
    padding: 0;
    margin: 0;
    list-style-type: none;

    > li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      border-bottom: 1px solid #eee;
      background-color: #f8f8f8;
      transition: all .3s;

      &.active {
        background-color: $primary-color;
        color: #fff;
      }

      &:not(.active):hover {
        background-color: lighten($color: $primary-color, $amount: 20);
        color: #fff;
      }
    }
  }
}
</style>
